var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.46 48.99",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.55,10.47,32.6,11.8a19.61,19.61,0,1,1-21.16-1l-.82-1.42a21.23,21.23,0,1,0,22.93,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35,27.76a13.87,13.87,0,0,1,1.51-6.28l1,2.5,1.52-.6L9.74,19.29a.8.8,0,0,0-.91-.49l-4.09.81.32,1.6,2.34-.46a15.5,15.5,0,0,0,6.79,20.84c.33.17.67.33,1,.47l.64-1.5A13.88,13.88,0,0,1,7.35,27.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.34,27.76a15.36,15.36,0,0,0-4.78-11.2l-1.13,1.18a13.88,13.88,0,0,1,.42,19.62c-.33.34-.68.67-1,1V35.93H28.17V40a.81.81,0,0,0,.66.8l4.08.82.32-1.6-2.33-.47A15.51,15.51,0,0,0,36.34,27.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22,10.73a.77.77,0,0,0-.41-.11H25.12L27.34,1a.82.82,0,0,0-.62-1l-.18,0H19.19a.81.81,0,0,0-.79.64l-3.27,14.7a.81.81,0,0,0,.8,1h6.34L20,26.77a.82.82,0,0,0,.5.94,1,1,0,0,0,.3.05.8.8,0,0,0,.7-.4l9-15.52A.8.8,0,0,0,30.22,10.73ZM22.71,22.07l1.36-6.38a.81.81,0,0,0-.62-1,.52.52,0,0,0-.17,0H16.94L19.85,1.63h5.67L23.3,11.25a.81.81,0,0,0,.61,1l.18,0h4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.78,24.09l-1.42.82a4.08,4.08,0,1,1-5.57-1.5,3.39,3.39,0,0,1,.67-.31l-.54-1.54a5.71,5.71,0,1,0,6.86,2.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.e5a998bd67fee5aea13efea62c8cc1e9.svg";
export { ForwardRef as ReactComponent };